import React from 'react';
import loaderimg from "../../assets/Loading_icon.gif";

const LoaderModal = ({ show, handleClose }) => {
  return (
   <div className={` ${show?'lodarmodal':''}`}>
      {/* <img src={loaderimg}/> */}
      {show?
      <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>:''}
   </div>
  );
};

export default LoaderModal;
